const AUDIO_MIME_RE = /^audio\/(webm|ogg|mpeg|mp3|mp4|m4a|x-m4a|wav|x-wav|wave)$/i;
const AUDIO_EXT_RE = /\.(webm|ogg|mp3|m4a|wav|mp4)$/i;
const MAX_AUDIO_BYTES = 12 * 1024 * 1024;
const MAX_AUDIO_MS = 10 * 60 * 1000;

const RECORDER_CANDIDATES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/ogg;codecs=opus',
];

function isAcceptedAudioFile(file) {
  if (!file) return false;
  const type = String(file.type || '').split(';')[0].trim();
  if (type && AUDIO_MIME_RE.test(type)) return true;
  return AUDIO_EXT_RE.test(String(file.name || ''));
}

function mimeForAudioFile(file) {
  const type = String(file && file.type || '').split(';')[0].trim().toLowerCase();
  if (type === 'audio/mp3' || type === 'audio/mpeg') return 'audio/mpeg';
  if (type === 'audio/x-m4a' || type === 'audio/m4a') return 'audio/mp4';
  if (type === 'audio/x-wav' || type === 'audio/wave') return 'audio/wav';
  if (type && AUDIO_MIME_RE.test(type)) return type;
  const name = String(file && file.name || '').toLowerCase();
  if (name.endsWith('.mp3')) return 'audio/mpeg';
  if (name.endsWith('.m4a') || name.endsWith('.mp4')) return 'audio/mp4';
  if (name.endsWith('.ogg')) return 'audio/ogg';
  if (name.endsWith('.wav')) return 'audio/wav';
  return 'audio/webm';
}

function pickRecorderMime(isTypeSupported) {
  const supported = typeof isTypeSupported === 'function'
    ? isTypeSupported
    : (globalThis.MediaRecorder && typeof globalThis.MediaRecorder.isTypeSupported === 'function'
      ? (type) => globalThis.MediaRecorder.isTypeSupported(type)
      : () => false);
  return RECORDER_CANDIDATES.find((type) => {
    try {
      return supported(type);
    } catch {
      return false;
    }
  }) || '';
}

function formatRecTimer(ms) {
  const total = Math.max(0, Math.floor(Number(ms) || 0) / 1000);
  const minutes = Math.floor(total / 60);
  const seconds = Math.floor(total % 60);
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

function splitTranscript(text) {
  return String(text || '')
    .replace(/\r\n/g, '\n')
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean);
}

function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function transcriptToHtml(text) {
  return splitTranscript(text)
    .map((line) => `<p>${escapeHtml(line)}</p>`)
    .join('');
}

module.exports = {
  AUDIO_MIME_RE,
  AUDIO_EXT_RE,
  MAX_AUDIO_BYTES,
  MAX_AUDIO_MS,
  RECORDER_CANDIDATES,
  isAcceptedAudioFile,
  mimeForAudioFile,
  pickRecorderMime,
  formatRecTimer,
  splitTranscript,
  transcriptToHtml,
};
